<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

    <v-container>
      <v-row no-gutters>
        <v-col cols="12" md="9">
          <v-tabs v-model="tabs" class="mb-2" center-active show-arrows background-color="transparent">
            <v-tab v-if="Object.keys(rechnungen).length === 0">Keine Rechnungen vorhanden</v-tab>
            <v-tab v-for="(rechnung, jahr) in rechnungen" :key="jahr">{{ jahr }}</v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-end align-center">
          <v-responsive max-width="300" class="mr-4">
            <v-text-field
              class="rounded-lg"
              dense
              flat
              solo
              hide-details
              v-model="search"
              append-icon="search"
              placeholder="Rechnungen durchsuchen"
              clearable
              @keydown.esc="search = ''"
            ></v-text-field>
          </v-responsive>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-tabs-items v-model="tabs" class="transparent">
        <v-tab-item v-for="(rechnung, jahr) in rechnungen" :key="jahr">
          <v-sheet class="overflow-auto pa-2" color="transparent">
            <v-data-iterator
              :loading="loading"
              :items="rechnung"
              :search="search"
              hide-default-footer
              sort-by="rechnung_datum"
              sort-desc
              no-data-text="Keine Rechnungen vorhanden"
              no-results-text="Keine Rechnungen gefunden"
            >
              <template v-slot:item="{ item }">
                <v-expansion-panels class="mb-4">
                  <v-expansion-panel class="rounded-lg">
                    <v-expansion-panel-header class="pa-1 pr-6">
                      <v-sheet class="d-flex justify-space-between pr-4">
                        <v-sheet class="rounded-lg d-flex align-center justify-center" width="64px">
                          <v-icon v-if="item.status === 'Gezahlt'" size="32" class="green--text">check_circle</v-icon>
                          <v-icon v-else class="red--text" size="32">cancel</v-icon>
                        </v-sheet>
                        <v-list-item-content>
                          <span class="font-weight-bold">
                            {{ item.rechnung_titel }}
                          </span>
                          <span class="text-subtitle-2 blue-grey--text">
                            {{ item.kasse }} | {{ item.rechnungsnummer }}
                          </span>
                        </v-list-item-content>
                        <span class="d-flex align-center text-subtitle-2">
                          {{ item.summe | money }}
                        </span>
                      </v-sheet>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="ma-0 pa-0">
                        <v-col cols="4" md="2">
                          <span class="caption font-weight-bold">Rechnungsnr.</span><br />
                          <span v-if="item.rechnungsnummer">{{ item.rechnungsnummer }}</span
                          ><br />
                        </v-col>
                        <v-col cols="4" md="2">
                          <span class="caption font-weight-bold">Rechnungsdatum</span><br />
                          <span v-if="item.rechnung_datum">{{ $filters.date(item.rechnung_datum, "DD.MM.YYYY") }}</span
                          ><br />
                        </v-col>
                        <v-col cols="4" md="2">
                          <span class="caption font-weight-bold">Zahlbar bis</span><br />
                          <span v-if="item.rechnung_zahlbar_bis">{{
                            $filters.date(item.rechnung_zahlbar_bis, "DD.MM.YYYY")
                          }}</span
                          ><br />
                        </v-col>
                        <v-col cols="4" md="2">
                          <span class="caption font-weight-bold">Kasse</span><br />
                          <span v-if="item.kasse">{{ item.kasse }}</span
                          ><br />
                        </v-col>
                        <v-col cols="4" md="2">
                          <span class="caption font-weight-bold">Rechnungsart</span><br />
                          <span v-if="item.rechnung_art">{{ item.rechnung_art }}</span>
                          <span v-else>-</span>
                        </v-col>
                        <v-col cols="4" md="2">
                          <span class="caption font-weight-bold">Gezahlt am</span><br />
                          <span v-if="item.gezahlt_datum">{{ $filters.date(item.gezahlt_datum, "DD.MM.YYYY") }}</span
                          ><br />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content class="rounded-b-lg grey lighten-4 pt-4">
                      <span class="d-flex justify-end">
                        <buttonRechnungDownload :small="true" icon="download" :rechnung="item" />
                        <buttonRechnungSenden :small="true" icon="outgoing_mail" :rechnung="item" />
                        <v-spacer></v-spacer>
                        <v-btn rounded text @click="(selectRechnung = item), showRechnungMethod()">
                          Details
                          <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
            </v-data-iterator>
          </v-sheet>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <dialogRechnung
      :visible.sync="showRechnung"
      :rechnungid="selectRechnung.id"
      @close="showRechnung = false"
    ></dialogRechnung>
  </v-container>
</template>

<script>
  export default {
    props: ["kontakt"],
    data() {
      return {
        headers: [
          { text: "", align: "left", value: "index" },
          { text: "Rechnungsnummer", align: "left", value: "rechnungsnummer" },
          { text: "Titel", align: "left", value: "rechnung_titel" },
          { text: "Kasse", align: "left", value: "kasse" },
          { text: "Rechnungsdatum", align: "right", value: "rechnung_datum" },
          { text: "Zahlbar bis", align: "right", value: "rechnung_zahlbar_bis" },
          { text: "Summe", align: "right", value: "summe" },
          { text: "", align: "left", value: "status" },
        ],
        search: "",
        showRechnung: false,
        rechnungid: "",
        selectRechnung: [],
        selected: [],
        tabs: 0,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        if (this.kontakt) {
          return this.kontakt;
        } else {
          return this.$getCurrentBbr();
        }
      },
      rechnungen() {
        this.$vars.loading = true;
        if (this.kontakt) {
          if (this.$store.state.rechnungen.loaded === false) {
            this.$store.dispatch("rechnungen/loadRechnungen");
          }
        } else {
          if (this.$store.state.rechnungen.loadedEigene === false) {
            if (this.currentBbr != null) {
              this.$store.dispatch("rechnungen/loadEigeneRechnungen", { user: this.currentBbr });
            }
          }
        }
        let rechnungen = this.$store.getters["rechnungen/nutzerRechnungen"](this.currentBbr);
        rechnungen.forEach((rechnung) => {
          if (rechnung.status === "Entwurf" || rechnung.status === "Entwurf SEPA") {
            rechnungen.splice(rechnungen.indexOf(rechnung), 1);
          }
          rechnung.jahr = rechnung.rechnung_datum.split("-")[0];
        });
        const key = "jahr";
        const result = {};
        let tabs = 0;
        rechnungen.forEach((item) => {
          if (!result[item[key]]) {
            result[item[key]] = [];
            tabs++;
          }
          result[item[key]].push(item);
        });
        this.tabs = tabs - 1;
        this.$vars.loading = false;
        return result;
      },
      sideHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "calc(100vh - 249px)";
          case "sm":
            return "calc(100vh - 249px)";
          case "md":
            return "calc(100vh - 249px)";
          case "lg":
            return "calc(100vh - 249px)";
          case "xl":
            return "calc(100vh - 249px)";
        }
      },
    },
    methods: {
      showRechnungMethod() {
        this.showRechnung = true;
        this.$firebase.analytics().logEvent("showRechnung", {
          currentBbr: this.currentBbr,
          rechnungID: this.selectRechnung.id,
          name: this.currentBbr,
        });
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// Rechnungen.vue?ac5aaa8c